// extracted by mini-css-extract-plugin
export default {"infoText":"_732e4e75","bold":"_3ffe8663"};